export const TooltipArrowIcon = ({
  width = 36,
  height = 24,
  className,
  title = "Tooltip Arrow",
  ...rest
}: IconProps) => {
  return (
    <svg
      data-testid="tooltip-arrow-icon"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 36 24"
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...rest}>
      <title>{title}</title>
      <path
        d="M27.9092 24C31.2219 23.9999 33.0983 20.2035 31.0869 17.5713L36 24L27.9092 24ZM0 24L4.68652 17.6309C2.74537 20.272 4.63081 23.9997 7.90918 24L0 24Z"
        fill="#F5F6F7"
      />
      <path
        d="M20.899 4.23825L31.0875 17.5713C33.0989 20.2036 31.222 24 27.9092 24L7.90964 24C4.63024 24 2.74425 20.2706 4.68789 17.6293L14.499 4.29622C16.0796 2.14822 19.2798 2.11923 20.899 4.23825Z"
        fill="#F5F6F7"
      />
    </svg>
  );
};
